<template>
  <div>
    <c-dialog ref="dialog" :title="titleName?titleName:pageName" width="1100" @resolve="resolve"
              :button-name="buttonName?buttonName:'确定'">
      <m-search ref="search" @search="search">
        <c-form ref="form" inline>
          <c-form-item v-if="systemConfig.pt_mode == 2 && systemConfig.operation_mode_enabled == 'ON'"
                       type="select" label="运营模式" name="operation_mode" :options="operationMode"></c-form-item>
          <c-form-item v-if="systemConfig.pt_mode == 2" type="hidden" name="stationed_id"></c-form-item>
          <c-form-item v-if="systemConfig.pt_mode == 2" type="input" label="所属商家" name="company_name" readonly
                       @click="$refs.stationedSelector.open()"></c-form-item>
          <c-form-item type="input" label="商品名称" name="product_name"></c-form-item>
          <c-form-item v-if="systemConfig.product_number_required == 'ON'" type="input" label="货号"
                       name="product_itemnumber" placeholder="精确匹配"></c-form-item>
          <c-form-item v-if="sku" type="input" label="SKU编码" name="product_sku_code"></c-form-item>
          <c-form-item v-if="systemConfig.share_enable == 'ON'" type="select" label="销售模式" name="sales_model"
                       :options="searchSalesModelOptions"></c-form-item>
          <c-form-item v-if="systemConfig.share_enable == 'ON'" type="checkbox" label="可售范围"
                       name="visible_user_level" :options="userLevelOptions"></c-form-item>
          <c-form-item v-if="systemConfig.product_custom == 'ON'" type="checkbox" label="定制" name="customs"
                       :options="iscustomData"></c-form-item>
          <c-form-item type="checkbox" label="状态" name="state" :options="productStateCheck"></c-form-item>
        </c-form>
      </m-search>

      <c-table ref="table" height="450">
        <c-table-column
            type="selector"
            :multiple="!!multiple"
        ></c-table-column>

        <c-table-column
            label="状态"
            name="state"
            width="60"
        >
          <template v-slot="{data}">
            <span v-if="data.state == 0" style="color:red">{{ dict.productState[data.state] }}</span>
            <span v-if="data.state == 1" style="color:#999999">{{ dict.productState[data.state] }}</span>
            <span v-if="data.state == 2" style="color:green">{{ dict.productState[data.state] }}</span>
            <span v-if="data.state == 3" style="color:blue">{{ dict.productState[data.state] }}</span>
            <span v-if="data.state == 4" style="color:red">{{ dict.productState[data.state] }}</span>
          </template>
        </c-table-column>

        <c-table-column
            label="运营模式"
            name="operation_mode"
            width="75"
            v-if="systemConfig.pt_mode == 2 && systemConfig.operation_mode_enabled == 'ON'"
        >
          <template v-slot="{data}">
            {{ operationModeName[data.operation_mode] }}
          </template>
        </c-table-column>

        <c-table-column
            label="商家角色"
            name="stationed_auth_name"
            width="125"
            v-if="systemConfig.pt_mode == 2 && systemConfig.stationed_authname_enabled == 'ON'"
        >
        </c-table-column>

        <c-table-column
            label="商家名称"
            name="stationed_name"
            width="150"
            v-if="systemConfig.pt_mode == 2"
        ></c-table-column>

        <c-table-column
            label="商品信息"
            name="product_name"
            width="280"
        >
          <template v-slot="{data}">
            <product-info v-if="data.product_itemnumber" :image="data.product_img_url"
                          :name="data.product_itemnumber + ' - '+data.product_name"></product-info>
            <product-info v-else :image="data.product_img_url" :name="data.product_name"></product-info>
          </template>
        </c-table-column>

        <c-table-column
            label="销售模式"
            width="75"
            name="sales_model"
            v-if="systemConfig.share_enable == 'ON'"
        >
          <template #default="{data}">
            <span v-if="data.sales_model == 1" style="color:blue">供货</span>
            <span v-else-if="data.sales_model == 2" style="color:darkgreen">直销</span>
            <span v-else>--</span>
          </template>
        </c-table-column>

        <c-table-column
            label="可售范围"
            width="80"
            name="visible_user_level_name"
            v-if="systemConfig.share_enable == 'ON'"
        >
          <template #default="{data}">
            <span v-if="data.visible_user_level_name && data.visible_user_level_name == '全部会员'" style="color:blue">全部会员</span>
            <span v-else v-for="(item, i) in data.visible_user_level_name.split(',')" :key="i"
                  style="color:darkslategrey;display: block;">{{ item }}</span>
          </template>
        </c-table-column>

        <c-table-column
            label="定制"
            width="60"
            name="is_custom"
            v-if="systemConfig.product_custom == 'ON'"
        >
          <template #default="{data}">
            <span v-if="data.is_custom == 1" style="color:blue">支持</span>
            <span v-else style="color:#999">不支持</span>
          </template>
        </c-table-column>

        <c-table-column
            v-if="sku"
            label="规格名称"
            name="product_sku_spec"
            width="120"
        ></c-table-column>

        <c-table-column
            v-if="sku"
            label="SKU编码"
            name="product_sku_code"
            width="90"
        ></c-table-column>

        <c-table-column
            v-if="!sku"
            label="所属类目"
            name="product_type_full_name"
            width="120"
        ></c-table-column>

        <c-table-column
            label="售价(元)"
            name="product_price"
            width="140"
        >
          <template v-slot="{data}">
            ￥{{ data.product_price }}
          </template>
        </c-table-column>

        <c-table-column
            v-if="sku"
            label="商品库存"
            name="stock_count"
            width="75"
        ></c-table-column>

      </c-table>
    </c-dialog>
    <stationed-selector ref="stationedSelector" @resolve="selectStationed"></stationed-selector>
  </div>
</template>

<script>
import productInfo from '@/components/public/product_info.vue'
import stationedSelector from '@/components/service/stationed_selector.vue'  // 商家库
import {mapState} from 'vuex'

export default {
  components: {
    productInfo,
    stationedSelector
  },

  props: {
    sku: Boolean,
    multiple: Boolean,
    buttonName: Boolean,
    titleName: Boolean
  },

  computed: {
    ...mapState(['dict']),
    ...mapState(['systemConfig']),

    pageName() {
      if (this.sku) {
        return "商品SKU库";
      } else {
        return "商品库";
      }
    },
  },

  data() {
    return {
      searchParams: {},
      productStateCheck: [{
        name: '草稿',
        value: 0
      }, {
        name: '上架',
        value: 2
      }, {
        name: '下架',
        value: 1
      }, {
        name: '待审核',
        value: 3
      }, {
        name: '已驳回',
        value: 4
      }],
      operationModeName: {
        1: '平台自营',
        2: '商家自营'
      },
      operationMode: [
        {name: '平台自营', value: 1},
        {name: '商家自营', value: 2}
      ],
      iscustomData: [{
        name: '支持',
        value: '1'
      }, {
        name: '不支持',
        value: '0'
      }],
      searchSalesModelOptions: [
        {name: '供货', value: 1},
        {name: '直销', value: 2}
      ],
      userLevelOptions: []
    }
  },
  mounted() {
      this.initUserLevelOptions();
  },
  methods: {
    search(data) {
      if (!data.state || data.state.length <= 0) {
        data.state = [1, 2];
      }
      data = Object.assign({}, data, this.searchParams);
      data.sku = this.sku ? 'sku' : ''
      this.$refs.table.load({
        url: this.sku ? '/product/sku/list' : '/product/list',
        data
      });
    },

    open(searchParams) {
      this.searchParams = searchParams || {};
      if (!this.searchParams.stationed_type) {
        this.searchParams.stationed_type = 1;
      }
      this.$refs.form.clear();
      this.$refs.search.search();
      this.$refs.dialog.open();
    },

    resolve(stop) {
      var data = this.$refs.table.getRow('selected');
      if (!data.length) {
        stop();
        this.$message({
          text: '请选择商品'
        });
        return;
      }
      this.$emit('resolve', data.map(row=>{
			return Object.assign({}, row.data);
		}));
    },

    selectStationed(data) {
      this.$refs.form.set({
        stationed_id: data[0].id,
        company_name: data[0].company_name
      });
    },
    //加载会员等级列表
    initUserLevelOptions() {
      this.request({
        url: '/user_level/options',
        data: {},
        success: data => {
          this.userLevelOptions = Array.from(data, item => {
            return {
              name: item.name,
              value: item.value
            }
          });
        }
      });
    }
  }
}
</script>